/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Arrayscape Gaming Dashboard API
 * Comprehensive REST API for event management, business operations, and analytics
 * OpenAPI spec version: 1.0.0
 */

export type GetReportsIncomeParamsGroupBy = typeof GetReportsIncomeParamsGroupBy[keyof typeof GetReportsIncomeParamsGroupBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetReportsIncomeParamsGroupBy = {
  GetReportsIncomeParamsGroupByDay: 'day',
  GetReportsIncomeParamsGroupByMonth: 'month',
  GetReportsIncomeParamsGroupByQuarter: 'quarter',
  GetReportsIncomeParamsGroupByWeek: 'week',
  GetReportsIncomeParamsGroupByYear: 'year',
} as const;
